import React, { useEffect, useState } from "react";
import styled from "styled-components";
import config from "../config/app.json";
import Link from "next/link";
import dynamic from "next/dynamic";
import { getContextPath, getIsPremiumTemplate } from "../helpers/utils";

const LazyImageComponent = dynamic(() => import("../components/LazyImage"));

const HeroTemplateWrapper = styled.section`
  display: flex;
  flex-direction: column;
  margin-bottom: 50px;
`;
const TemplateContainer = styled.div`
  display: flex;
  flex-direction: column;
  margin: 40px 50px 0px 50px;
  border-bottom: 1px solid #efefef;
  @media (max-width: 425px) {
    margin: 20px 15px 0px 15px;
  }
`;

const MainPageTitleContainer = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 100%;
  margin-bottom: 25px;
  a {
    text-decoration: none;
  }
  @media (max-width: 425px) {
    justify-content: center;
  }
`;

const MainPageTitle = styled.h2`
  font-family: "Lato";
  font-size: 24px;
  color: #1d1d1d;
  font-weight: bold;
  margin: 0;
`;

const MainPageLink = styled(Link)``;

const MainPageSubHeading = styled(MainPageTitle)`
  font-size: 18px;
  a {
    text-decoration: none;
    color: #1d1d1d;
  }
  img {
    width: 24px;
    height: 14px;
    padding-right: 10px;
  }
  @media (max-width: 425px) {
    display: none;
  }
`;

const ListWrapper = styled.div`
  display: flex;
  flex-wrap: nowrap;
  overflow-x: auto;
  overflow-y: hidden;
  scroll-behavior: smooth;
  ::-webkit-scrollbar {
    display: none;
  }
  -ms-overflow-style: none;
  scrollbar-width: none;
  img {
    display: inline-block;
    width: 200px;
    max-width: none;
    border-radius: 4px;
  }
`;

const TemplateListWrapper = styled.div`
  display: flex;
  flex-wrap: nowrap;
  overflow-x: auto;
  overflow-y: hidden;
  scroll-behavior: smooth;
  align-items: flex-end;
  ::-webkit-scrollbar {
    display: none;
  }
  -ms-overflow-style: none;
  scrollbar-width: none;
`;

const TemplateWrapper = styled.div`
  display: flex;
  margin-right: 20px;
  width: 100%;
  justify-content: center;
  align-items: center;
  flex-direction: column;
`;

const Template = styled.a`
  width: ${(props) => `${props.width}px` || "120px"};
  height: ${(props) => `${props.height}px` || "60px"};
  background-color: ${(props) => props.color || "#ffe6e6"};
  border-radius: 5px;
  display: flex;
  justify-content: center;
  align-items: center;
  cursor: pointer;
`;

const TemplateTitle = styled.p`
  font-size: 14px;
  margin: 10px 0;
  text-align: center;
  color: #54536c;
  white-space: nowrap;
  cursor: pointer;
`;

const TemplateTitleLink = styled.a`
  text-decoration: none;
`;

const TemplateListContainer = styled.div`
  display: flex;
  position: relative;
  margin-bottom: 40px;
  @media (max-width: 425px) {
    margin-bottom: 20px;
  }
`;

const ListSliderIcon = styled.span`
  position: absolute;
  cursor: pointer;
  z-index: 1;
  width: 50px;
  height: 50px;
  top: 50%;
  -ms-transform: translateY(-50%);
  transform: translateY(-50%);
`;

const LeftSliderIcon = styled(ListSliderIcon)`
  background-image: url(${(props) => props.url});
  background-repeat: no-repeat;
  left: -35px;
  display: none;
  @media (max-width: 425px) {
    left: -15px;
  }
`;

const RightSliderIcon = styled(ListSliderIcon)`
  background-image: url(${(props) => props.url});
  background-repeat: no-repeat;
  right: -35px;
  ${(props) => !props.toShowRightSlider && `display: none`};
  @media (max-width: 425px) {
    right: -15px;
  }
`;

const SeeAllContainer = styled.div`
  justify-content: center;
  display: none;
  margin: 30px 0px;
  @media (max-width: 425px) {
    display: flex;
  }
`;

const SeeAllButton = styled.span`
  width: 100px;
  height: 35px;
  border: 1px solid #efefef;
  border-radius: 18px;
  display: flex;
  justify-content: center;
  align-items: center;
  a {
    color: #54536c;
    text-decoration: none;
  }
`;

const appUrl = config["APPURLS"][config["APPURLS"]["current"]];
const apiUrl = config["APIURIS"][config["APIURIS"]["current"]];
// const apiUrl = config["APIURIS"]["demo"];
const BASE_PATH = process.env.BASE_PATH;

function HomeTemplateListingSection({ data, searchData }) {
  const [isLoaded, setIsLoaded] = useState(false);

  useEffect(() => {
    setIsLoaded(true);
  }, []);

  function handleLeftClick(event) {
    const element = event.target.nextSibling.nextSibling;
    let offsetHeight = element.offsetWidth;
    element.scrollLeft -= offsetHeight;
  }

  function handleRightClick(event) {
    const element = event.target.nextSibling;
    let offsetHeight = element.offsetWidth;
    element.scrollLeft += offsetHeight;
  }

  function handleScroll(event) {
    const element = event.target;
    let topVal = element.scrollLeft;
    let totalHeight = element.scrollWidth;
    let offsetHeight = element.offsetWidth;

    if (topVal + offsetHeight >= totalHeight) {
      element.parentElement.children[1].style.display = "none";
    } else if (topVal === 0) {
      element.parentElement.children[0].style.display = "none";
      element.parentElement.children[1].style.display = "block";
    } else if (topVal > 0) {
      element.parentElement.children[0].style.display = "block";
      element.parentElement.children[1].style.display = "block";
    }
  }
  function getPath(currentCategory) {
    const current = searchData.filter(
      (data) => data["_source"].category === currentCategory
    );
    if (current.length > 0) {
      return `/${current[0]["_source"].page_url}`;
    }
    return "/";
  }

  function checkScrollWidth({ category }) {
    const element = document.getElementById(category);
    if (element.scrollWidth > window.innerWidth) {
      return true;
    }
    return false;
  }

  return (
    <HeroTemplateWrapper>
      <TemplateContainer key={"Create_Template"}>
        <MainPageTitleContainer>
          <MainPageTitle>Create design</MainPageTitle>
        </MainPageTitleContainer>
        <TemplateListContainer>
          <LeftSliderIcon
            url={`${appUrl}static/icons/slide-left-arrow.svg`}
            onClick={handleLeftClick}
          />
          <RightSliderIcon
            url={`${appUrl}static/icons/slide-right-arrow.svg`}
            onClick={handleRightClick}
            toShowRightSlider={true}
          />
          <TemplateListWrapper onScroll={handleScroll}>
            {searchData &&
              searchData.map((category, index) => (
                <TemplateWrapper key={index}>
                  <Link href={`/${category["_source"].page_url}`} passHref>
                    <Template
                      width={category["_source"].width}
                      height={category["_source"].height}
                      color={category["_source"].background}
                      rel="noopener"
                      onClick={() => window.scrollTo(0, 0)}
                    >
                      <img
                        src={`${appUrl}static/imagesizes/${category["_source"].img}`}
                        alt={`${getContextPath(
                          category["_source"].name
                        )}-template-img`}
                        width={
                          category["_source"].name
                            .toLowerCase()
                            .includes("facebook")
                            ? "30px"
                            : "40px"
                        }
                        height={
                          category["_source"].name
                            .toLowerCase()
                            .includes("facebook")
                            ? "30px"
                            : "40px"
                        }
                      />
                    </Template>
                  </Link>
                  <Link href={`/${category["_source"].page_url}`} passHref>
                    <TemplateTitleLink
                      rel="noopener"
                      onClick={() => window.scrollTo(0, 0)}
                    >
                      <TemplateTitle>{category["_source"].name}</TemplateTitle>
                    </TemplateTitleLink>
                  </Link>
                </TemplateWrapper>
              ))}
          </TemplateListWrapper>
        </TemplateListContainer>
      </TemplateContainer>
      {data.map((template, index) => (
        <TemplateContainer key={index}>
          <MainPageTitleContainer>
            <MainPageLink href={getPath(template.category)} passHref>
              <a rel="noopener" onClick={() => window.scrollTo(0, 0)}>
                <MainPageTitle>{template.name_en}</MainPageTitle>
              </a>
            </MainPageLink>
            <MainPageSubHeading>
              <Link href={getPath(template.category)} passHref scroll={true}>
                <a rel="noopener" onClick={() => window.scrollTo(0, 0)}>
                  See all
                </a>
              </Link>
              <img
                src={`${BASE_PATH}/images/icon-see-all-arrow.svg`}
                alt="icon-see-all"
                width="14px"
                height="14px"
              />
            </MainPageSubHeading>
          </MainPageTitleContainer>
          <TemplateListContainer>
            <LeftSliderIcon
              url={`${appUrl}static/icons/slide-left-arrow.svg`}
              onClick={handleLeftClick}
            />
            {isLoaded && (
              <RightSliderIcon
                url={`${appUrl}static/icons/slide-right-arrow.svg`}
                onClick={handleRightClick}
                toShowRightSlider={checkScrollWidth(template)}
              />
            )}
            <ListWrapper id={template.category} onScroll={handleScroll}>
              {template["data"].map((item, index) => {
                const isPremium = getIsPremiumTemplate(
                  item["_source"]["plan"],
                  item["_source"]["type"],
                  item["_source"]["subtype"]
                    ? item["_source"]["subtype"]
                    : item["_source"]["subType"]
                );

                return (
                  <Link
                    href={`/?templateId=${item["_source"].template_url}&tid=${item["_source"].id}`}
                    key={index}
                    as={`/p/${item["_source"].template_url}`}
                    shallow
                  >
                    <a>
                      <LazyImageComponent
                        key={index}
                        src={`${appUrl}scene-prebuilts/thumbnails/${item["_source"].thumb}`}
                        alt={`${getContextPath(
                          item["_source"].name_en
                        )}-thumbnail-img`}
                        width={item["_source"].width}
                        height={item["_source"].height}
                        display_size={item["_source"].display_size}
                        category={template["name_en"]}
                        context={"home-page"}
                        isPremium={isPremium}
                      />
                    </a>
                  </Link>
                );
              })}
            </ListWrapper>
          </TemplateListContainer>
          <SeeAllContainer>
            <SeeAllButton>
              <Link href={getPath(template.category)} passHref scroll={true}>
                <a rel="noopener" onClick={() => window.scrollTo(0, 0)}>
                  See all
                </a>
              </Link>
            </SeeAllButton>
          </SeeAllContainer>
        </TemplateContainer>
      ))}
    </HeroTemplateWrapper>
  );
}

export default React.memo(HomeTemplateListingSection);
